import React from 'react';
import { Panel } from '@deque/cauldron-react';
import styles from './TestDetails.css';
import type {
  FilteredUserFlowResults,
  Filters
} from '@deque/axe-devtools-issues-utils';
import UserFlowSummary from './UserFlowSummary';
import UserFlowOverview from './UserFlowOverview';
import UserFlowResultsView from './UserFlowResults';

interface UserFlowDetailsProps {
  results: FilteredUserFlowResults;
  filters: Filters;
  narrow: boolean;
}

const UserFlowDetails: React.FC<UserFlowDetailsProps> = ({
  results,
  filters,
  narrow
}) => {
  return (
    <Panel collapsed={narrow} className={styles.TestDetails}>
      <UserFlowSummary results={results} filters={filters} />
      <UserFlowOverview results={results} filters={filters} />
      <UserFlowResultsView results={results} />
    </Panel>
  );
};

export default UserFlowDetails;
